import { Delete } from "@mui/icons-material";
import { Box, Typography, Button, TextField, IconButton, Autocomplete, FormControl, FormGroup, FormHelperText, useTheme } from "@mui/material";
import { useFormikContext, FieldMetaProps, FieldArray, Field, FieldInputProps } from "formik";
import { ConfigItem as Item } from "../../../app/backendTypes";
import { useLegalUnits } from "../../../app/hooks";

export function ItemApprovedForCompanies(props: { loading: boolean }) {
    const loading = props.loading;

    const { values, getFieldMeta, setFieldValue } = useFormikContext<Item>();
    const { units: legalUnits } = useLegalUnits();
    const theme = useTheme();

    if (values.company_permissions === undefined) return <></>;

    const meta: FieldMetaProps<string>[] = [];


    for (let i = 0; i < values.company_permissions.approved_ids.length; i++) {
        const metaStep = `company_permissions.approved_ids[${i}]`;
        meta.push(getFieldMeta(`${metaStep}`));
    }

    return (

        <FieldArray
            name="company_permissions.approved_ids"
            render={(arrayHelpers) => (
                <>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography color="text.secondary">
                            This tool is available only for following legal units
                        </Typography>
                        <Button
                            onClick={() => arrayHelpers.insert(0, "")}
                            disabled={loading}
                            color="secondary"
                        >
                            Add Company
                        </Button>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        {values.company_permissions?.approved_ids.map((company, i) => (
                            <Box
                                key={i}
                                sx={{ display: "flex", alignItems: "center", gap: 2 }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                        width: "100%",
                                        alignItems: "baseline",
                                    }}
                                >
                                    <Field name={`company_permissions.approved_ids[${i}]`}>
                                        {({ field }: { field: FieldInputProps<unknown> }) => {
                                            const meta = getFieldMeta(`company_permissions.approved_ids[${i}]`);

                                            return (
                                                <FormControl sx={{ width: "inherit" }}>
                                                    <FormGroup>
                                                        <Autocomplete
                                                            disabled={loading}
                                                            value={
                                                                legalUnits.find(
                                                                    (l) => l.id === values.company_permissions?.approved_ids[i]
                                                                ) || null
                                                            }
                                                            options={legalUnits.filter(l => !values.company_permissions?.restricted_ids.includes(l.id))}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder={
                                                                        loading ? "Loading..." : "Legal Unit"
                                                                    }
                                                                    sx={{
                                                                        input: {
                                                                            "&::placeholder": {
                                                                                color:
                                                                                    meta.touched && Boolean(meta.error)
                                                                                        ? theme.palette.error.main
                                                                                        : "text.secondary",
                                                                                opacity: 1,
                                                                            },
                                                                        },
                                                                    }}
                                                                />
                                                            )}
                                                            getOptionLabel={(unit) => unit.name}
                                                            onChange={(_, value) =>
                                                                setFieldValue(`company_permissions.approved_ids[${i}]`, value?.id || "")
                                                            }
                                                        />

                                                        {meta.touched && Boolean(meta.error) && (
                                                            <FormHelperText error>
                                                                {meta.error}
                                                            </FormHelperText>
                                                        )}
                                                    </FormGroup>
                                                </FormControl>
                                            );
                                        }}
                                    </Field>

                                </Box>
                                <IconButton
                                    onClick={() => arrayHelpers.remove(i)}
                                    disabled={loading}
                                >
                                    <Delete color={loading ? "disabled" : "error"} />
                                </IconButton>
                            </Box>
                        ))}
                    </Box>
                </>
            )}
        />
    );
}